import type { SearchResultType } from '@atlassian/search-client/common/types';

export const getJiraSearchResultTypeMetadata: (
	type: SearchResultType,
) =>
	| 'object'
	| 'space'
	| 'document'
	| 'spreadsheet'
	| 'presentation'
	| 'repository'
	| 'pull-request'
	| 'branch'
	| 'commit'
	| 'message'
	| 'page'
	| 'blogpost'
	| 'attachment'
	| 'whiteboard'
	| 'comment'
	| 'database'
	| 'embed'
	| 'folder'
	| 'calendar'
	| 'question'
	| 'issue'
	| 'incident'
	| 'filter'
	| 'plan'
	| 'board'
	| 'card'
	| 'goal'
	| 'tag'
	| 'work-item'
	| 'ask'
	| 'dashboard'
	| 'deal'
	| 'gliffy'
	| 'customer-org'
	| 'data-table'
	| 'type'
	| 'schema'
	| 'position'
	| 'learning'
	| 'channel'
	| 'email'
	| 'focus_area'
	| 'focus_area_status_update'
	| 'organization'
	| 'organization_status_update'
	| 'sharepoint-document'
	| 'slide'
	| 'unrecognised' = (type: SearchResultType) => {
	if (type === 'project') {
		return 'space';
	}
	return type;
};
